/*
 * @Description: 取消重复请求等工具
 * @Author: wangbo16
 * @Date: 2021-08-21 17:22:30
 * @LastEditors: wangbo16
 * @LastEditTime: 2021-08-21 17:48:16
 */
import qs from 'qs';
import axios from 'axios';

function generateReqKey(config) {
  const { method, url, params, data } = config;
  // 上传图片时，data不参与key生成
  // TODO 待优化为根据data内存大小判断
  if (data && data.bases64) {
    return [method, url, qs.stringify(params)].join('&');
  }
  return [method, url, qs.stringify(params), qs.stringify(data)].join('&');
}

class SameRequestUtils {
  private static instance: null | SameRequestUtils;

  private pendingRequest = new Map();

  public static getInstance() {
    if (!SameRequestUtils.instance) {
      SameRequestUtils.instance = new SameRequestUtils();
    }
    return SameRequestUtils.instance;
  }

  public addPendingRequest(config) {
    const requestKey = generateReqKey(config);
    // eslint-disable-next-line no-param-reassign
    config.cancelToken =
      config.cancelToken ||
      new axios.CancelToken((cancel) => {
        if (!this.pendingRequest.has(requestKey)) {
          this.pendingRequest.set(requestKey, cancel);
        }
      });
  }

  public removePendingRequest(config) {
    const requestKey = generateReqKey(config);
    if (this.pendingRequest.has(requestKey)) {
      const cancelToken = this.pendingRequest.get(requestKey);
      cancelToken(requestKey);
      this.pendingRequest.delete(requestKey);
    }
  }
}

export default SameRequestUtils.getInstance();
